import MessageSender from '@/helper/MessageSender'

const messages = {
    cz: {
        not_auth: 'Neautorizovaný požadavek. Zkuste znovu načít stránku.',
        client_error: 'Neočakávaná klientská chyba: {status}',
        server_error: 'Neočakávaná serverová chyba: {status}',
    },
}

export default class ResponseHandler {
    response: Response;

    constructor (response: Response) {
        this.response = response
    }

    handle (): boolean {
        if (this.response.status === 401) {
            new MessageSender(messages).sendError('not_auth')
            return false
        }

        if (this.response.status >= 401 && this.response.status < 500) {
            new MessageSender(messages).sendError('client_error', { status: this.response.status })
            return false
        }

        if (this.response.status > 500) {
            new MessageSender(messages).sendError('server_error', { status: this.response.status })
            return false
        }

        return true
    }
}
